module.exports = __webpack_public_path__ + "img/sign-hb.19b9446e.png";